module.exports = __webpack_public_path__ + "static/media/snoopyrainy01.320ce0cc.gif";